import React from 'react';
import Layout from '../Maker.layout';
import { useCoverFields, worksheetActions } from '@src/stores/worksheet.store';

const Input = ({ label, name, value, onChange }) => (
  <label className="inputlabel" style={{ width: '100%' }}>
    {label}
    <br />
    <input
      style={{ marginTop: 5, width: '100%' }}
      className="input"
      name={name}
      onChange={(e) => {
        onChange(e.target.value);
      }}
      value={value}
    />
  </label>
);

const Cover = () => {
  const title = useCoverFields('title');
  const subtitle = useCoverFields('subtitle');
  const comments = useCoverFields('comments');
  const timeAllowed = useCoverFields('timeAllowed');
  const totalMarks = useCoverFields('totalMarks');
  const startDate = useCoverFields('startDate');

  return (
    <Layout>
      <Input
        label="Title"
        name="title"
        onChange={(v) => {
          worksheetActions.setCoverText('title', v);
        }}
        value={title}
      />

      <Input
        label="Subtitle"
        name="subtitle"
        onChange={(v) => {
          worksheetActions.setCoverText('subtitle', v);
        }}
        value={subtitle}
      />
      <Input
        label="Comments"
        name="comments"
        onChange={(v) => {
          worksheetActions.setCoverText('comments', v);
        }}
        value={comments}
      />
      <Input
        label="Time Allowed"
        name="timeAllowed"
        onChange={(v) => {
          worksheetActions.setCoverText('timeAllowed', v);
        }}
        value={timeAllowed}
      />
      <Input
        label="Total Marks"
        name="totalMarks"
        onChange={(v) => {
          worksheetActions.setCoverText('totalMarks', v);
        }}
        value={totalMarks}
      />
      <Input
        label="Start Date"
        name="startDate"
        onChange={(v) => {
          worksheetActions.setCoverText('startDate', v);
        }}
        value={startDate}
      />
    </Layout>
  );
};

export default Cover;
